<script lang="ts" setup>
const {
  height = '16px',
  value = 0
} = defineProps<{
  /** Height of progress bar. Units must be provided e.g. `16px` */
  height?: string

  /** Progress value */
  value?: number | string

  infinite?: boolean
}>()
</script>

<template>
  <div class="bar" :class="{ infinite }">
    <slot />
  </div>
</template>

<style scoped lang="sass">
.bar
  --height: v-bind(height)
  --value: v-bind(`${+value - 100}%`)

  @apply relative h-$height w-full rounded-xl overflow-clip bg-primary-500/10

  &:after
    @apply $fill-[$fill-color,@theme-colors-primary-500] bg-$fill
    @apply content-[''] absolute inset-0

    transform: translateX(var(--value))
    transition: transform 300ms ease

    animation: progress-appear 1s ease

.bar.infinite:after
  animation: infinite-progress 1s ease infinite

@keyframes progress-appear
  from
    transform: translateX(-100%)

@keyframes infinite-progress
  from
    transform: translateX(-100%)

  to
    transform: translateX(100%)

//;
</style>
